import { EventBus } from '@/event-bus'
import * as joint from '@clientio/rappid'
import { ArtifactType } from '@/models'
import { Events } from '@/models/events.model'
import BurgerMenu from './../burger-menu'
import { useTraceDataStore } from '@/stores/traceDataStore'
import { useHelpers } from './helpers'
import { injectTyped } from '@/inject'
import { ServiceKeys } from '@/services/symbols'

export function useRegisterArtifactTypeContainerMenu() {
  const rappidContext = injectTyped(ServiceKeys.rappidContext)

  const { getArtifactTypeFromCellView, addTool } = useHelpers()

  const traceDataStore = useTraceDataStore()

  let currentlySelectedCell: joint.dia.CellView | null = null

  function openArtifactTypeContainerMenu(cell: joint.dia.ElementView, burgerMenu: BurgerMenu) {
    const currentArtifactType = cell.model.attributes.artifactType as ArtifactType | undefined

    if (currentArtifactType) {
      const artifactTypeFromStore = traceDataStore.modelState.artifactTypes.find(
        (at) => at.id === currentArtifactType.id,
      )

      if (artifactTypeFromStore) {
        const position = {
          x: burgerMenu.el.getBoundingClientRect().x,
          y: burgerMenu.el.getBoundingClientRect().y,
        }

        const inputData: Events['openContainerMenuArtifactType'] = {
          artifactType: artifactTypeFromStore,
          button: burgerMenu,
          cellView: cell,
          position: position,
        }
        EventBus.emit('openContainerMenuArtifactType', inputData)
      }
    }
  }

  function applySelection(cellView: joint.dia.CellView) {
    // Deselect previous cell
    if (currentlySelectedCell && currentlySelectedCell !== cellView) {
      currentlySelectedCell.model.removeAttr('isSelected')
    }

    // Select new cell
    currentlySelectedCell = cellView
    cellView.model.attr('isSelected', true)
  }

  function registerArtifactTypeContainerMenu() {
    const burgerMenu = new BurgerMenu((cellView: joint.dia.CellView) => {
      if (
        cellView instanceof joint.dia.ElementView &&
        getArtifactTypeFromCellView(cellView) !== undefined
      ) {
        openArtifactTypeContainerMenu(cellView, burgerMenu)
      }
    })

    rappidContext.paper.on('element:mouseenter', (cellView: joint.dia.CellView) => {
      if (
        !cellView.model.get('isPill') &&
        !cellView.model.get('isSelected') &&
        getArtifactTypeFromCellView(cellView) !== undefined
      ) {
        addTool(cellView, burgerMenu)
      }
    })

    rappidContext.paper.on('element:pointerclick', (cellView: joint.dia.CellView) => {
      if (!cellView.model.get('isPill') && getArtifactTypeFromCellView(cellView) !== undefined) {
        applySelection(cellView)
      }
    })
  }

  return { registerArtifactTypeContainerMenu }
}
